import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import React from "react";
import styled from "styled-components";
import { AspectRatioPicture } from "@faire/retailer-visitor-shared/components/Image/AspectRatioPicture";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { ShowroomAnimatedCategoryTile } from "@faire/retailer/features/Showroom/ShowroomAnimatedCategoryTile/ShowroomAnimatedCategoryTile";
var ZOOM_IN_SCALE = 1.1;
export var ImageTextLinkTile = function(param) {
    var keyString = param.keyString, link = param.link, image = param.image, images = param.images, text = param.text, imageSizeInfo = param.imageSizeInfo, handleStyledLinkOnClick = param.handleStyledLinkOnClick, dataTestId = param.dataTestId, useShowroomAnimatedTile = param.useShowroomAnimatedTile, className = param.className, handleStyledLinkOnHover = param.handleStyledLinkOnHover, parentCategoryName = param.parentCategoryName, showBorder = param.showBorder, onVisible = param.onVisible;
    var isSSR = useIsSSR();
    var imageLink = image ? optimizeImageUrl(image, isSSR, _object_spread({
        resizeMethod: "fill"
    }, imageSizeInfo)) : EAEAEA_PIXEL;
    var _imageSizeInfo_ratio;
    return /*#__PURE__*/ _jsx("div", {
        ref: onVisible,
        children: /*#__PURE__*/ _jsxs(StyledLink, {
            linkTo: link !== null && link !== void 0 ? link : "",
            onDragStart: onDragStart,
            onClick: handleStyledLinkOnClick,
            "data-test-id": dataTestId,
            className: className,
            onMouseEnter: handleStyledLinkOnHover,
            children: [
                useShowroomAnimatedTile && (images === null || images === void 0 ? void 0 : images.length) ? /*#__PURE__*/ _jsx(ShowroomAnimatedCategoryTile, {
                    images: images
                }) : /*#__PURE__*/ _jsx(StyledAspectRatioPicture, {
                    $width: "100%",
                    $ratio: (_imageSizeInfo_ratio = imageSizeInfo.ratio) !== null && _imageSizeInfo_ratio !== void 0 ? _imageSizeInfo_ratio : imageSizeInfo.width / imageSizeInfo.height,
                    $hideBorder: !showBorder,
                    children: /*#__PURE__*/ _jsx(StyledImage, {
                        src: imageLink,
                        alt: text,
                        style: {
                            width: "100%",
                            height: "100%"
                        },
                        width: "100%",
                        height: "100%"
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "1x"
                }),
                parentCategoryName !== undefined ? /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraphSansRegular",
                    color: Core.text.subdued,
                    children: parentCategoryName
                }) : null,
                /*#__PURE__*/ _jsx(StyledTypography, {
                    children: /*#__PURE__*/ _jsx(AnimatedUnderlineText, {
                        children: text !== null && text !== void 0 ? text : ""
                    })
                })
            ]
        }, keyString)
    });
};
var onDragStart = function(e) {
    return e.preventDefault();
};
var StyledImage = styled.img.withConfig({
    componentId: "sc-9bbb5bc8-0"
})([
    "transition:transform 1200ms cubic-bezier(0.17,0.67,0.24,1);transform-origin:left;"
]);
var AnimatedUnderlineText = styled.span.withConfig({
    componentId: "sc-9bbb5bc8-1"
})([
    "background-image:linear-gradient( ",
    ",",
    " );background-size:0 1px;background-position:0 100%;background-repeat:no-repeat;transition:background-size 1200ms cubic-bezier(0.17,0.67,0.24,1);"
], Core.surface.enabled, Core.surface.enabled);
var StyledLink = styled(EmbeddedLink).withConfig({
    componentId: "sc-9bbb5bc8-2"
})([
    "display:flex;text-decoration:none;flex-direction:column;align-items:flex-start;",
    "{&:hover{text-decoration:none;",
    "{transform:scale(",
    ");}",
    "{background-size:100% 1px;}}}"
], responsiveMediaQueries.canHover, StyledImage, ZOOM_IN_SCALE, AnimatedUnderlineText);
var StyledAspectRatioPicture = styled(AspectRatioPicture).withConfig({
    componentId: "sc-9bbb5bc8-3"
})([
    "overflow:hidden;"
]);
var StyledTypography = styled(Typography).attrs({
    variant: "paragraphSansRegular",
    color: Core.text.enabled
}).withConfig({
    componentId: "sc-9bbb5bc8-4"
})([
    ""
]);
export var ImageTextLinkTileStyles;
(function(ImageTextLinkTileStyles) {
    ImageTextLinkTileStyles.Text = StyledTypography;
    ImageTextLinkTileStyles.UnderlineText = AnimatedUnderlineText;
    ImageTextLinkTileStyles.Image = StyledImage;
})(ImageTextLinkTileStyles || (ImageTextLinkTileStyles = {}));
